import { useWatch } from 'react-hook-form';

import type { FormFields } from '@/entities/purchase-form';

import { BopisDeliveryDetails } from './BopisDeliveryDetails';
import { SddDeliveryDetails } from './SddDeliveryDetails';
import { SthDetails } from './SthDetails';
import './DeliveryDetails.scss';

const details = {
    bopis: BopisDeliveryDetails,
    sdd: SddDeliveryDetails,
    sth: SthDetails,
};

export const DeliveryDetails = () => {
    const currentValue = useWatch<FormFields, 'fulfilmentMethod'>({ name: 'fulfilmentMethod' });
    const DetailsComponent = details[currentValue];

    return (
        <div data-testid="pdp-delivery-details" className="delivery-details">
            <DetailsComponent />
        </div>
    );
};
